import { render, staticRenderFns } from "./ModalCategoriasChatbot.vue?vue&type=template&id=004aef9e&scoped=true&"
import script from "./ModalCategoriasChatbot.vue?vue&type=script&lang=js&"
export * from "./ModalCategoriasChatbot.vue?vue&type=script&lang=js&"
import style0 from "./ModalCategoriasChatbot.vue?vue&type=style&index=0&id=004aef9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004aef9e",
  null
  
)

export default component.exports